























































import { Component, Mixins } from 'vue-property-decorator';
import UsersPasswordModal from './users-password.modal.vue';
import UserModal from './users.modal.vue';
import TableMixin from '../../../mixins/table.mixin';

@Component({
  components: { UsersPasswordModal, UserModal },
})
export default class UsersShell extends Mixins(TableMixin) {
  columns = [
    {
      label: 'GENERAL.STATUS',
      name: 'isActive',
      sortable: true,
      align: 'center',
    },
    { label: 'GENERAL.NAME', name: 'name', sortable: true },
    { label: 'GENERAL.SURNAME', name: 'surname', sortable: true },
    {
      label: 'GENERAL.COMPANY',
      name: 'company',
      field: (row: any) => row.company?.name,
      sortable: true,
    },
    { label: 'GENERAL.EMAIL', name: 'email', sortable: true },
    {
      label: 'GENERAL.USER_ROLE',
      name: 'role',
      field: (row: any) => row.role?.name,
      sortable: true,
    },
    { label: 'GENERAL.ACTIONS', name: 'actions', align: 'center' },
  ];

  userModal = {
    open: false,
    id: '',
  };

  passModal = {
    open: false,
    id: '',
  };

  openModal(id = '') {
    this.userModal.id = id;
    this.userModal.open = true;
  }

  openPassModal(id: string) {
    this.passModal.id = id;
    this.passModal.open = true;
  }
}
